<template>
    <div class="wflow-container wflow-container-top-bar">
        <div class="header-title">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px">
                <PageHeader :sys-title="''"></PageHeader>
                <span style="margin-top: 10px">{{ logoTitle }}</span>
            </div>
            <TopBtn v-if="TopBtn.length > 0" ref="TopBtn" :top-btn="TopBtn" />
        </div>
        <div class="wflow-busiattach">
            <!--正文编辑 -->
            <div class="mainform-have-sidebar" :style="{ width: InlineTextEditorShow ? '100%' : '' }">
                <ModuleTextEditor ref="InlineTextEditor" :wf-attach-url="wfAttachUrl" :office-type="officeType" :body-file-editor="2" :vo="vo"></ModuleTextEditor>
            </div>
        </div>
    </div>
</template>

<script>
// import moment from 'moment'
import ModuleTextEditor from './ModuleTextEditor'
import TopBtn from './TopBtn'
export default {
    components: {
        ModuleTextEditor,
        TopBtn
    },
    props: {},
    data() {
        return {
            officeType: 'ech5', // 支持的编辑模式
            wfAttachUrl: 'htgl/htmb', // 当前wfAttachUrl
            bodyfile: {}, // 编辑的文件本体
            logoTitle: '', // 当前标题
            TopBtn: [
                {
                    btnAlign: 1,
                    btnCode: null,
                    btnGroupId: null,
                    btnIcon: 'glyphicon-off.svg',
                    btnJavascript: 'btnCloseClick()',
                    btnName: '关 闭',
                    btnOrderNo: null,
                    btnShow: null,
                    btnType: '1',
                    id: null,
                    nodeId: null,
                    passenger: {},
                    visitType: 0
                },
                {
                    btnAlign: 1,
                    btnCode: null,
                    btnGroupId: null,
                    btnIcon: 'saved.svg',
                    btnJavascript: 'btnSaveAndCloseClick()',
                    btnName: this.$tx('pageBtns.saveAndClose', '保存关闭'),
                    btnOrderNo: null,
                    btnShow: null,
                    btnType: '1',
                    id: null,
                    nodeId: null,
                    passenger: {},
                    visitType: 0
                },
                {
                    btnAlign: 1,
                    btnCode: null,
                    btnGroupId: null,
                    btnIcon: 'save.svg',
                    btnJavascript: 'btnSaveClick()',
                    btnName: this.$tx('pageBtns.save', '保存'),
                    btnOrderNo: null,
                    btnShow: null,
                    btnType: '1',
                    id: null,
                    nodeId: null,
                    passenger: {},
                    visitType: 0
                }
            ], // 顶部按钮集合
            vo: {},
            actionType: '',
            InlineTextEditorShow: true
        }
    },
    computed: {},
    watch: {},
    created() {
        this.logoTitle = this.$route.query.title
        this.vo = JSON.parse(this.$route.query.row)
        console.log(this.logoTitle, this.vo, 'query 参数传递')
        // 按钮事件
        this.TopBtn.forEach((btn) => {
            let btnClick = btn.btnJavascript
            if (btnClick.indexOf('(') !== -1) {
                let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                if (btnParams !== '') {
                    btnParams = btnParams.replace(/'/g, '').split(',')
                    btn.btnParams = btnParams
                }
                btnClick = btnClick.split('(')[0]
            }
            if (this[btnClick] !== undefined) {
                btn.btnClick = this[btnClick]
            }
        })
    },
    beforeDestroy() {},
    mounted() {
        this.$bus.emit('btnOpenWordClick', this)
    },
    methods: {
        /**
         * 关闭事件
         */
        btnCloseClick(Boolean) {
            if (Boolean) {
                window.close()
                return
            }
            if (confirm(this.$tx('gwgl.messages.editConfig', '若当前编辑未保存，则内容修改无效，是否继续？'))) {
                window.close()
            } else {
                return
            }
        },
        /**
         * 关闭且保存
         */
        btnSaveAndCloseClick() {
            console.log('关闭且保存')
            this.btnSubmitClick('SaveAndClose')
        },
        /**
         * 保存
         */
        btnSaveClick() {
            this.btnSubmitClick('Save')
        },
        /**
         * 保存事件
         */
        btnSubmitClick(actionType, saveCallback) {
            this.formValidate(() => {
                this.actionType = actionType
                if (this.InlineTextEditorShow && actionType !== 'AutoSave') {
                    console.log(' this.$refs.InlineTextEditor.$refs.ecweboffice', this.$refs.InlineTextEditor.$refs.ecweboffice)
                    this.$refs.InlineTextEditor.$refs.ecweboffice.save()
                    return
                }

                if (actionType === 'SaveAndClose') {
                    this.$message.success(this.$tx('common.saveSuccess'))
                    setTimeout(() => {
                        this.btnCloseClick(true)
                    }, 300)
                }
                if (actionType === 'Save') {
                    this.$message.success(this.$tx('common.saveSuccess'))
                }

                this.InlineTextEditorShow = true
            })
        }
    }
}
</script>

<style scoped lang="scss">
.top_title {
    & > span {
        display: inline-block;
    }
    .main_head {
        font-size: 22px;
        &.main_head_slicer {
            padding-right: 10px;
            margin-right: 10px;
            position: relative;
            &::after {
                content: '';
                position: absolute;
                right: 0;
                width: 0px;
                height: 0px;
                top: 14px;
                background: #fff;
                opacity: 0.2;
            }
        }
    }
    .sub_head {
        font-size: 16px;
        margin-right: 6px;
    }
}
/deep/ .page-header-container {
    border-bottom: 0px solid !important;
}
.wflow-container-bottom-bar {
    .wflow-container-loaded {
        height: calc(100vh - 70px);
        padding-bottom: 98px;
    }

    /deep/ .bottom-bar {
        @media (max-width: 1569px) {
            width: 980px;
        }

        @media (min-width: 1570px) {
            width: 1200px;
        }

        margin-bottom: 10px;
    }
}

.wflow-container-top-bar .wflow-container-loaded {
    height: calc(100vh - 70px);
}

.mainform-container {
    overflow-y: hidden;
    overflow-x: hidden;
    margin-top: 0px;

    .el-scrollbar {
        width: 100%;
        height: calc(100vh - 70px);

        /deep/ .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }

    .mainform-have-sidebar {
        display: inline-block;
    }

    .mainform-sidebar {
        display: inline-block;
        vertical-align: top;
        background-color: #fff;
        border-left: solid 1px #f3f3f3;
    }

    .sidebar-attach-container {
        background-color: #fff;
        position: relative;
    }

    .not-have-bottom-idealist {
        min-height: calc(100vh - 90px) !important;
    }

    .page-container {
        min-height: 100%;
        background: #fff;
        position: relative;
        margin: 10px auto;

        .form-container {
            position: relative;
            margin: 0 auto;
            padding-top: 30px;
            padding-bottom: 20px;

            .form-header {
                padding-bottom: 20px;

                .form-title {
                    font-size: 24px;
                    font-weight: normal;
                    text-align: center;
                    color: #545454;
                }
            }

            .wflow-busiform {
                /deep/.el-table {
                    border-radius: 0 !important;
                }
            }
        }

        /deep/ .el-loading-mask {
            margin-top: 100px;
        }
    }
}

.wflow-container {
    background-color: #f0f2f8;
    font-weight: 400;
    font-size: 14px;

    @media (max-width: 1569px) {
        min-width: 1280px;

        .mainform-have-sidebar {
            // width: calc(100% - 280px);
        }

        .mainform-sidebar {
            width: 280px;
        }

        .page-container {
            width: 980px;

            .form-container {
                width: 860px;
            }
        }
    }

    @media (min-width: 1570px) {
        min-width: 1570px;

        .mainform-have-sidebar {
            // width: calc(100% - 350px);
        }

        .mainform-sidebar {
            width: 350px;
        }

        .page-container {
            width: 1200px;

            .form-container {
                width: 1000px;
            }
        }
    }

    .header-title {
        height: 70px;
        min-width: 1200px;
        padding: 12px 0;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        justify-content: space-between;
        color: #999;
        font-size: 12px;
        background: #fff;

        .route-info {
            margin-left: 16px;
            display: flex;
            align-items: center;
        }

        .section-title {
            display: flex;
            margin-right: 11px;
            margin-left: 10px;
            font-size: 13px;
            align-items: center;
            position: relative;

            .formTapBtn {
                position: absolute;
                bottom: 0px;
                display: flex;
                left: 50px;
                font-family: MicrosoftYaHei;
                color: #000000;
                font-size: 14px;
                width: 420px;

                .tapItemBtn {
                    position: relative;
                    margin-right: 15px;
                }

                .active {
                    position: relative;
                    color: var(--subjectColor);
                    font-weight: bold;

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: -10px;
                        left: 0px;
                        width: 100%;
                        height: 2px;
                        background: var(--subjectColor);
                    }
                }

                .tapItemBtn:hover {
                    cursor: pointer;
                    color: var(--subjectColor);
                }
            }

            .l-text {
                padding-right: 10px;
                position: relative;
                top: -12px;

                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1px;
                    height: 14px;
                    background-color: #d8d8d8;
                }
            }

            .l1-text {
                padding-right: 10px;
                position: relative;
            }

            .r-text {
                padding-left: 10px;
                position: relative;
                top: -12px;
            }
        }
    }
}
</style>
